export default class Config {
    public static SpecialGiftAmount = 2800;

    public static SpecialGiftAmountUSD = 10;
}
